// A post's body: its prose, and between it the passages it quotes, each
// fetched as the post is read, and the charts it draws. One parse, cut at each
// (`renderParts`), so a footnote still links across one.
import { renderParts } from "@bibleunleashed/shared";
import { useMemo } from "react";
import { BadChart, Chart } from "@/charts/Chart";
import { useTermMatcher } from "@/lib/glossary";
import { Quotation } from "./Quotation";

export function PostBody({ md }: { md: string }) {
  const terms = useTermMatcher();
  const parts = useMemo(() => renderParts(md, terms), [md, terms]);
  return (
    <>
      {parts.map((part, i) => {
        switch (part.kind) {
          case "prose":
            return <div key={i} className="prose" dangerouslySetInnerHTML={{ __html: part.html }} />;
          case "quote":
            return <Quotation key={`${i}-${part.osis}`} osis={part.osis} display={part.display} />;
          case "chart":
            return <Chart key={i} chart={part.chart} />;
          case "bad-chart":
            return <BadChart key={i} error={part.error} />;
        }
      })}
    </>
  );
}
